<footer class="kexp-footer text-default-700">
  <div class="footer-container">
    <div class="logo-container">
      <a href="https://kexp.org/" target="_blank" class="logo">
        <img src="/assets/kexp-logo-footer.svg" alt="KEXP"/>
      </a>
    </div>
    <div class="tag-line font-bold text-sm">
      LISTENER-POWERED KEXP - WHERE THE MUSIC MATTERS
    </div>
    <div class="links-col"></div>
  </div>
  <div class="text-center text-sm mt-4">
    <span class="whitespace-nowrap"><a href="https://www.kexp.org/terms-and-conditions/" target="_blank">TERMS OF USE</a></span>
    <span class="ml-4 sm:ml-8 whitespace-nowrap"><a href="https://www.kexp.org/privacy-policy/" target="_blank">PRIVACY POLICY</a></span>
  </div>
</footer>
